import { css } from '../utils/dom.js';
import { position, stop, addEvt, cleanEvt } from '../utils/event.js';
import { isKeyCode } from '../utils/key-composition.js';
import { client } from '../plugins/Platform.js';
import throttle from '../utils/throttle.js';
import { $q } from '../install.js';

function showRipple(evt, el, ctx, forceCenter) {
  ctx.modifiers.stop === true && stop(evt);
  var color = ctx.modifiers.color;
  var center = ctx.modifiers.center;
  center = center === true || forceCenter === true;

  var node = document.createElement('span'),
      innerNode = document.createElement('span'),
      pos = position(evt),
      _el$getBoundingClient = el.getBoundingClientRect(),
      left = _el$getBoundingClient.left,
      top = _el$getBoundingClient.top,
      width = _el$getBoundingClient.width,
      height = _el$getBoundingClient.height,
      diameter = Math.sqrt(width * width + height * height),
      radius = diameter / 2,
      centerX = "".concat((width - diameter) / 2, "px"),
      x = center ? centerX : "".concat(pos.left - left - radius, "px"),
      centerY = "".concat((height - diameter) / 2, "px"),
      y = center ? centerY : "".concat(pos.top - top - radius, "px");

  innerNode.className = 'q-ripple__inner';
  css(innerNode, {
    height: "".concat(diameter, "px"),
    width: "".concat(diameter, "px"),
    transform: "translate3d(".concat(x, ",").concat(y, ",0) scale3d(.2,.2,1)"),
    opacity: 0
  });
  node.className = "q-ripple".concat(color ? ' text-' + color : '');
  node.setAttribute('dir', 'ltr');
  node.appendChild(innerNode);
  el.appendChild(node);

  var abort = function abort() {
    node.remove();
    clearTimeout(timer);
  };

  ctx.abort.push(abort);
  var timer = setTimeout(function () {
    innerNode.classList.add('q-ripple__inner--enter');
    innerNode.style.transform = "translate3d(".concat(centerX, ",").concat(centerY, ",0) scale3d(1,1,1)");
    innerNode.style.opacity = 0.2;
    timer = setTimeout(function () {
      innerNode.classList.remove('q-ripple__inner--enter');
      innerNode.classList.add('q-ripple__inner--leave');
      innerNode.style.opacity = 0;
      timer = setTimeout(function () {
        node.remove();
        ctx.abort.splice(ctx.abort.indexOf(abort), 1);
      }, 275);
    }, 250);
  }, 50);
}

function updateModifiers(ctx, _ref) {
  var modifiers = _ref.modifiers,
      value = _ref.value,
      arg = _ref.arg;
  var cfg = Object.assign({}, $q.config.ripple, modifiers, value);
  ctx.modifiers = {
    early: cfg.early === true,
    stop: cfg.stop === true,
    center: cfg.center === true,
    color: cfg.color || arg,
    keyCodes: [].concat(cfg.keyCodes || 13)
  };
}

function destroy(el) {
  var ctx = el.__qripple;

  if (ctx !== void 0) {
    ctx.abort.forEach(function (fn) {
      fn();
    });
    cleanEvt(ctx, 'main');
    delete el._qripple;
  }
}

export default {
  name: 'ripple',
  inserted: function inserted(el, binding) {
    if (el.__qripple !== void 0) {
      destroy(el);
      el.__qripple_destroyed = true;
    }

    var ctx = {
      enabled: binding.value !== false,
      modifiers: {},
      abort: [],
      start: function start(evt) {
        if (ctx.enabled === true && evt.qSkipRipple !== true && ( // on ENTER in form IE emits a PointerEvent with negative client cordinates
        client.is.ie !== true || evt.clientX >= 0) && evt.type === (ctx.modifiers.early === true ? 'pointerdown' : 'click')) {
          showRipple(evt, el, ctx, evt.qKeyEvent === true);
        }
      },
      keystart: throttle(function (evt) {
        if (ctx.enabled === true && evt.qSkipRipple !== true && isKeyCode(evt, ctx.modifiers.keyCodes) === true && evt.type === "key".concat(ctx.modifiers.early === true ? 'down' : 'up')) {
          showRipple(evt, el, ctx, true);
        }
      }, 300)
    };
    updateModifiers(ctx, binding);
    el.__qripple = ctx;
    addEvt(ctx, 'main', [[el, 'pointerdown', 'start', 'passive'], [el, 'click', 'start', 'passive'], [el, 'keydown', 'keystart', 'passive'], [el, 'keyup', 'keystart', 'passive']]);
  },
  update: function update(el, binding) {
    var ctx = el.__qripple;

    if (ctx !== void 0 && binding.oldValue !== binding.value) {
      ctx.enabled = binding.value !== false;

      if (ctx.enabled === true && Object(binding.value) === binding.value) {
        updateModifiers(ctx, binding);
      }
    }
  },
  unbind: function unbind(el) {
    if (el.__qripple_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qripple_destroyed;
    }
  }
};